import { render } from "./NieuwsBrief.vue?vue&type=template&id=33afb2e6&scoped=true"
import script from "./NieuwsBrief.vue?vue&type=script&lang=js"
export * from "./NieuwsBrief.vue?vue&type=script&lang=js"

import "./NieuwsBrief.vue?vue&type=style&index=0&id=33afb2e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33afb2e6"]])

export default __exports__